module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/async-validator/~/babel-runtime/~/core-js/library/modules/_fails.js
// module id = vKxD
// module chunks = 0